module.exports = __webpack_public_path__ + "img/usun.44e632fd.svg";